<i18n>
  {
    "en": {
      "title": "Support games",
      "more": "and more"
    },
    "zhHant": {
      "title": "支援遊戲",
      "more": "看更多"
    },
    "ja": {
      "title": "サポートゲーム",
      "more": "その他"
    },
    "ko": {
      "title": "지원하는 게임",
      "more": "더보기"
    }
  }
</i18n>

<template>
  <section class="my-5">
    <v-container>
      <v-layout column wrap align-center justify-center>
        <v-flex xs12>
          <div class="headline">{{ $t('title') }}</div>
        </v-flex>
      </v-layout>
      <v-layout row wrap justify-center>
        <v-flex v-if="canShowGame('tsum')" xs12 sm6 md4>
          <TsumIntro />
        </v-flex>
        <v-flex v-if="canShowGame('cookieKingdom')" xs12 sm6 md4 id="cookieKingdom">
          <CookieKingdomIntro />
        </v-flex>
        <v-flex v-if="canShowGame('mlb9i')" xs12 sm6 md4>
          <MLB9InningsIntro />
        </v-flex>
      </v-layout>
      <div v-if="displayGame" class="more-button-container">
        <button @click="showAllGames" class="more-button">{{ $t('more') }}</button>
      </div>
    </v-container>
  </section>
</template>

<script>
import TsumIntro from './intro.TsumTsum';
import CookieKingdomIntro from './intro.CookieKingdom';
import MLB9InningsIntro from './intro.MLB9Innings';

export default {
  name: 'supportGames',
  components: {
    TsumIntro,
    CookieKingdomIntro,
    MLB9InningsIntro,
  },
  data() {
    return {
      displayGame: '',
    };
  },
  mounted() {
    if (location.hash === '#cookieKingdom') {
      document.getElementById('cookieKingdom').scrollIntoView();
    }

    this.displayGame = this.$route.query.game || '';
  },
  methods: {
    canShowGame(game) {
      return this.displayGame === game || this.displayGame === '';
    },
    showAllGames() {
      this.displayGame = '';
      this.$router.replace({ query: null });
    },
  },
};
</script>

<style scoped>
.more-button-container {
  text-align: center;
  margin-top: 16px;
}
.more-button {
  text-transform: uppercase;
  font-weight: 700;
  width: 100%;
  padding: 12px;
  border-radius: 4px;
  background-color: #f5f5f5;
}
.more-button:hover {
  border: 1px solid #212121;
}
</style>
